import { render, staticRenderFns } from "./JobPagination.vue?vue&type=template&id=183f9d06&scoped=true&"
import script from "./JobPagination.vue?vue&type=script&lang=js&"
export * from "./JobPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183f9d06",
  null
  
)

export default component.exports